import React from 'react';
import { Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { STATUSES, STATUS_COLORS, getStatusColor } from '../helpers/statusConfig';

const useStyles = makeStyles(() => ({
  pill: {
    display: 'inline-block',
    textAlign: 'center',
    padding: '0.25rem 0.6rem',
    borderRadius: '0.45rem',
    fontSize: '0.875rem',
    color: 'white',
    whiteSpace: 'normal',
    width: 160,
    lineHeight: 1.3,
  },
  overlay: {
    marginLeft: 6,
  },
}));

const StatusPill = ({ statusId, statusDescription, overlays = [] }) => {
  const classes = useStyles();
  const s = STATUSES[statusId];
  const displayLabel = statusDescription || (s && s.label);
  if (!displayLabel) return null;
  const c = s ? getStatusColor(statusId) : STATUS_COLORS.neutral;

  return (
    <span>
      <Typography
        variant='body1'
        component='span'
        className={classes.pill}
        style={{
          backgroundColor: c.bg,
          border: `2px solid ${c.bg}`,
          color: c.fg,
        }}
      >
        {displayLabel}
      </Typography>
      {overlays.map((oid) => {
        const o = STATUSES[oid];
        if (!o) return null;
        const oc = getStatusColor(oid);
        return (
          <Tooltip key={oid} title={o.label} arrow>
            <Typography
              variant='body1'
              component='span'
              className={`${classes.pill} ${classes.overlay}`}
              style={{
                backgroundColor: oc.bg,
                border: `2px solid ${oc.bg}`,
              }}
            >
              {o.label}
            </Typography>
          </Tooltip>
        );
      })}
    </span>
  );
};

export default React.memo(StatusPill);
